module.exports = __webpack_public_path__ + "static/img/kv.df3e269.png";


//////////////////
// WEBPACK FOOTER
// ./static/ruzhu/kv.png
// module id = liSc
// module chunks = 1